import type { IMapper } from "~/types";
import { type IRenderConfig, type IRenderConfigResponseModel } from "~/types";

export const onboardingRenderModelMapper: IMapper<
  IRenderConfigResponseModel,
  IRenderConfig
> = (value) => value;
